(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function kur(kok) {
    var ray = kok.querySelector('[data-hsl-track]');
    if (!ray) return;
    var slaytlar = Array.prototype.slice.call(ray.querySelectorAll('.hsl-slide'));
    if (slaytlar.length < 2) return;

    var noktaKabi = kok.querySelector('[data-hsl-noktalar]');
    var azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bekleme = parseInt(kok.getAttribute('data-autoplay'), 10) || 0;
    var sayac = null;

    // Her sayfa acilisinda ILK slayttan basla. Tarayici kaydirma konumunu
    // geri yukleyebildigi icin bu acikca sifirlaniyor.
    ray.scrollLeft = 0;

    var noktalar = slaytlar.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hsl-nokta';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', (i + 1) + '. slayt');
      b.addEventListener('click', function () { git(i); });
      if (noktaKabi) noktaKabi.appendChild(b);
      return b;
    });

    // TEK DOGRULUK KAYNAGI: hangi slayttayiz sorusunun cevabi her zaman
    // GERCEK kaydirma konumundan okunur, ayri bir sayactan degil.
    // Ayri sayac tutuldugunda su hata cikmisti: sayfa ARKA PLAN sekmesinde
    // acildiginda tarayici yumusak kaydirmayi calistirmiyor, gorsel yerinde
    // kaliyor ama sayac ilerliyordu; noktalar 3'u isaretlerken ekranda 1.
    // slayt duruyordu.
    function mevcut() {
      var en = 0, fark = Infinity;
      slaytlar.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - ray.scrollLeft);
        if (d < fark) { fark = d; en = i; }
      });
      return en;
    }

    function isaretle() {
      var i = mevcut();
      noktalar.forEach(function (n, j) {
        n.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
    }

    function git(i) {
      var hedef = (i + slaytlar.length) % slaytlar.length;
      ray.scrollTo({ left: slaytlar[hedef].offsetLeft, behavior: azHareket ? 'auto' : 'smooth' });
    }

    kok.querySelector('[data-hsl-onceki]').addEventListener('click', function () { git(mevcut() - 1); });
    kok.querySelector('[data-hsl-sonraki]').addEventListener('click', function () { git(mevcut() + 1); });

    // Parmakla, okla veya klavyeyle kaydirinca noktalar kendiliginden guncellenir
    var zamanlayici;
    ray.addEventListener('scroll', function () {
      clearTimeout(zamanlayici);
      zamanlayici = setTimeout(isaretle, 90);
    }, { passive: true });

    function basla() {
      // Gizli sekmede baslatma: tarayici animasyonu calistirmaz, bosuna doner.
      if (!bekleme || azHareket || document.hidden) return;
      dur();
      sayac = setInterval(function () { git(mevcut() + 1); }, bekleme);
    }
    function dur() { if (sayac) { clearInterval(sayac); sayac = null; } }

    // Ustune gelince, odaklaninca ve sekme arka plandayken dur
    kok.addEventListener('mouseenter', dur);
    kok.addEventListener('mouseleave', basla);
    kok.addEventListener('focusin', dur);
    kok.addEventListener('focusout', basla);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { dur(); } else { basla(); }
    });

    // 2. ve 3. gorsel `loading="lazy"`: ilk yuke yuk bindirmiyorlar. Ama
    // otomatik gecis 7 saniyede 2. slayta gectigi icin, o an gorsel hic
    // yuklenmemisse bir an bos zemin gorunur. Sayfa yuklendikten SONRA,
    // bos bir anda tembel isareti kaldirilip sessizce hazirlaniyorlar.
    function sonrakileriHazirla() {
      slaytlar.slice(1).forEach(function (s) {
        var im = s.querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      });
    }
    var hazirla = function () {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(sonrakileriHazirla, { timeout: 3000 });
      } else {
        setTimeout(sonrakileriHazirla, 1500);
      }
    };
    if (document.readyState === 'complete') { hazirla(); }
    else { window.addEventListener('load', hazirla, { once: true }); }

    isaretle();
    basla();
  }

  function hepsi() {
    document.querySelectorAll('[data-hsl]').forEach(kur);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsi);
  } else {
    hepsi();
  }
  // Tema editorunde bolum yeniden yuklendiginde tekrar kur
  document.addEventListener('shopify:section:load', hepsi);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
